// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBXXuPmA8-DX-tHFDAaJZbvppMJzPBTtas",
  authDomain: "ozzieducationgroup.firebaseapp.com",
  projectId: "ozzieducationgroup",
  storageBucket: "ozzieducationgroup.firebasestorage.app",
  messagingSenderId: "894066774932",
  appId: "1:894066774932:web:1c8dfd04661bf2be39b581",
  measurementId: "G-R91JKP7HYM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);  
export const functions = getFunctions(app); 